import { Autocomplete } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

/**
 * MUTAXASSISLIK kiritish maydoni.
 *
 * `Autocomplete`, `Select` EMAS — ataylab: ro'yxat YOPIQ bo'lmasligi kerak.
 * Fan nomlari bilan cheklab qo'ysak "KPP", "Qabul", "Psixolog", "Farrosh" kabi
 * qiymatlarni kiritib bo'lmasdi; erkin matn qoldirsak esa "Matematika",
 * "matematika" va "Math" yonma-yon paydo bo'lardi.
 *
 * Shuning uchun server TAKLIF beradi (maktabda allaqachon ishlatilgan qiymatlar
 * + fan nomlari), admin esa yozishni boshlashi bilan mavjudini ko'radi va
 * odatda o'shani tanlaydi. Yangi qiymat kerak bo'lsa — shunchaki yozadi.
 */
export function SpecialtyInput(props: {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const { data: takliflar = [] } = useQuery({
    queryKey: ['staff-specialties'],
    queryFn: async () => (await api.get<string[]>('/staff/specialties')).data,
    staleTime: 5 * 60_000, // ro'yxat kam o'zgaradi — har modal ochilganda so'ramaymiz
  });

  return (
    <Autocomplete
      label={t('staffPage.specialty')}
      description={t('staffPage.specialtyHint')}
      placeholder={t('staffPage.specialtyPlaceholder')}
      data={takliflar}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      maxLength={40}
      comboboxProps={{ withinPortal: true }}
    />
  );
}
